import styled from 'styled-components'

export const Calendar = ({
  dates,
  secondary,
}: {
  dates: Date[]
  secondary?: boolean
}) => {
  return (
    <Container>
      {dates.map((date, index) => (
        <Bloc key={`calendar-page-${index}`}>
          <DateContainer>
            <Month secondary={secondary}>
              {date
                .toLocaleDateString('fr-CH', {
                  month: 'short',
                })
                .replace('.', '')}
            </Month>
            <Day secondary={secondary}>{date.getDate()}</Day>
          </DateContainer>
          {dates.length === 2 && index < dates.length - 1 && (
            <Divider>au</Divider>
          )}
        </Bloc>
      ))}
    </Container>
  )
}

const Bloc = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
`

const Container = styled.div`
  display: flex;
  font-family: var(--font-sans-serif);
  text-transform: uppercase;
  align-items: center;
`

const Divider = styled.div`
  margin-left: 10px;
`

const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  box-shadow: 0px 0px 5px 0px ${({ theme }) => theme.textColor}22;
  border: 1px solid #99999933;
`

const Month = styled.div<{ secondary?: boolean }>`
  font-size: 14px;
  font-weight: 100;
  background: ${({ theme, secondary }) =>
    `rgb(${secondary ? theme.secondaryColor : theme.mainColor})`};
  width: 100%;
  text-align: center;
  line-height: 2;
  color: white;
`

const Day = styled.div<{ secondary?: boolean }>`
  font-size: 40px;
  font-weight: 900;
  background: ${({ theme }) => theme.backgroundColor};
  width: 100%;
  text-align: center;
  line-height: 1.1;
  border-radius: 2px 2px 5px 5px;
  color: ${({ theme, secondary }) =>
    `rgb(${secondary ? theme.secondaryColor : theme.mainColor})`};
`
